import { render } from "./blackCard.vue?vue&type=template&id=b3222766"
import script from "./blackCard.vue?vue&type=script&lang=js"
export * from "./blackCard.vue?vue&type=script&lang=js"

import "./blackCard.vue?vue&type=style&index=0&id=b3222766&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__